import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { APP_CONFIG, DiagnosticVerbosity, provideSignageClock } from '@cubigo/digital-signage';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AuthConfig, OAuthLogger, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';

import { authConfig } from 'app/shared/configs/auth.config';
import { GlobalErrorHandler } from 'app/shared/error-handler';
import { httpInterceptors } from 'app/shared/interceptors';
import { MultiTranslatePoHttpLoader } from 'app/shared/loaders/multi-translate-po-http.loader';
import { OauthLoggerService } from 'app/shared/services/oauth-logger.service';

import { environment } from 'environments/environment';

import { routes } from './app.routes';

export function createTranslateLoader(): MultiTranslatePoHttpLoader {
  return new MultiTranslatePoHttpLoader([
    { prefix: '/assets/i18n/login', suffix: '.po' },
    { prefix: '/assets/i18n/digital-signage', suffix: '.po' }
  ]);
}

// Verbose sends every allow-listed event; prod keeps to incidents so the estate does not pay for
// per-slide telemetry it never reads. A remote diagnostics push still overrides this per display.
function defaultVerbosity(): DiagnosticVerbosity {
  return environment.name === 'prod' ? DiagnosticVerbosity.Normal : DiagnosticVerbosity.Verbose;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideSignageClock(),
    provideHttpClient(withInterceptors(httpInterceptors)),
    provideOAuthClient(),
    { provide: OAuthLogger, useExisting: OauthLoggerService },
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'en-US',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader
        }
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: ['acc', 'uat', 'prod'].includes(environment.name),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: AuthConfig, useValue: authConfig },
    { provide: OAuthStorage, useFactory: (): Storage => localStorage },
    { provide: APP_CONFIG, useValue: { ...environment, diagnostics: { defaultVerbosity: defaultVerbosity() } } }
  ]
};
